module.exports = __webpack_public_path__ + "img/1CirPat.272f5d2f.png";